export const UnknownTenantPage = () => {
  return (
    <>
      <h1>oops! sorry. unknown tenant.</h1>
    </>
  )
}